<template>
  <div>    
    <button
      class="btn btn-warning"
      @click="abrirModalAgregarListado()"
      :disabled = "current.estatus === false"
    >      
      <i class="fas fa-plus"></i>Agregar por cats
    </button>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="agregarListadoModal"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg" role="document" style="max-width:50%">
        <div
          class="modal-content text-center"
          style="width: 100%; max-width: 100%"
        >
          <button
            aria-label="Close"
            class="close"
            @click="cerrarModalAgregarListado()"
            type="button"
          >
            <span class="close-label">Cerrar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-content">
            <h5 class="modal-title text-success">Agregar Listados (Categorías/Subcategorías) al cupón</h5>  
            <br/>            
            <div class="d-flex" style="gap:10px">
              <!------------------------COL CATEGORIAS---------------------------->              
              <div class="flex-shrink-0 border border-3 rounded" style="max-height: 700px; width:50%">
                <h5 class="text-success mt-2">Categorías</h5>            
                <div class="input-group mb-3 px-3 ">
                  <input type="text"
                    class="form-control"
                    placeholder="Categorias"
                    v-model="searchQuery"
                    @input="onSearchInputCategoria"                    
                    >
                    <div class="input-group-append">
                      <button class="btn btn-success"
                        @click=onSearchInputCategoria
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                </div>
                <div>
                  <span class="badge">{{ Object.keys(categoriaSeleccionada).length !==0  ? categoriaSeleccionada.codigo + " -- " + categoriaSeleccionada.nombre : "" }}</span>
                  <span class="badge badge-danger"
                    style="cursor: pointer; user-select:none; "
                    @click="limpiarCategoriaSeleccionada()"
                  >
                    <i class="fa fa-times"                      
                      v-if="Object.keys(categoriaSeleccionada).length !==0"                      
                    ></i>
                  </span>
                </div>
                  
                <div class="mt-2" style="max-height: 600px; overflow-y:auto">  
                    <!----------------- tabla------------------ -->
                    <table class="table table-striped table-hover">                    
                      <tbody>
                        <template v-for="cat in categoriasList">
                          <tr>
                            <td 
                              @click="clickedCategoria(cat)"
                            >
                              {{ cat.codigo }} -- {{ cat.nombre }}
                            </td>
                            <td>
                              <button class="btn btn-success"
                                @click="agregarCategoria(cat)">
                                <i class="fa fa-plus"></i>
                              </button>   
                            </td>
                          </tr>
                        </template> 
                      </tbody>
                    </table>
                    <!----------------- tabla------------------ -->                  
                </div>                
              </div> 
              <!------------------------fin COL CATEGORIAS---------------------------->
              &nbsp;
              <!------------------------ COL SUB CATEGORIAS---------------------------->              
              <div class="flex-shrink-0 border border-3 rounded" style="width:50%">
                <h5 class="text-success mt-2">SubCategorías</h5>                
                <div class="row">  
                    <div class="input-group mb-2 px-3 ">
                      <input type="text"
                        class="form-control"
                        placeholder="Subcategorias"   
                        v-model="searchQuerySubcategoria"
                        @input="onSearchInputSubcategoria"    
                        :disabled="Object.keys(categoriaSeleccionada).length ===0"    
                        ref="inputSubcategoria"           
                      >
                      <div class="input-group-append">
                        <button class="btn btn-success"
                          @click="onSearchInputSubcategoria"
                          :disabled="Object.keys(categoriaSeleccionada).length ===0"    
                          ref="inputSubcategoria"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>                  
                </div>         
                <div class="mt-2">
                  <span class="badge">{{ Object.keys(subcategoriaSeleccionada).length!==0 ? subcategoriaSeleccionada.codigo + " -- " + subcategoriaSeleccionada.nombre : "" }}</span>
                  <span class="badge badge-danger"
                    style="cursor: pointer; user-select:none;"
                    @click="limpiarSubcategoriaSeleccionada()"
                  >
                    <i class="fa fa-times"                      
                      v-if="Object.keys(subcategoriaSeleccionada).length!==0"></i>
                  </span>
                </div>
                <div class="mt-2" style="max-height: 600px; overflow-y:auto">   
                  <div v-if="errores.errorSubcategoria">
                    <h6 class="text-center">{{ current.errorSubcategoria }}</h6>
                  </div>   
                  <table class="table table-striped table-hover">                    
                    <tbody>
                      <template v-for="subcat in subcategoriasList" v-if="!current.errorSubcategoria">
                        <tr>
                          <td>
                            {{ subcat.codigo }} -- {{ subcat.nombre }}
                          </td>
                          <td>
                            <button class="btn btn-success"
                              @click="agregarSubcategoria(subcat)">
                              <i class="fa fa-plus"></i>
                            </button>   
                          </td>
                        </tr>
                      </template> 
                    </tbody>
                  </table>
                </div>
              </div>             
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CategoriaSelectComponent from "@/components/commons/CategoriaSelectComponent ";  
  import DynamicService from "@/services/commons/DynamicService";
  import Notifications from "@/notifications/notifications";
  import {debounce} from 'lodash'

  export default{
    components: {
      CategoriaSelectComponent,
      DynamicService,
    },
    props: ["cuponera","current"],
    data(){
      return{
        errores:{},
        categoriasList:[],
        busqueda: '',
        searchQuery:'',
        searchQuerySubcategoria:'',
        buscarCategoriasDebounce:null,
        buscarSubcategoriasDebounce:null,
        subcategoriasList:[],
        categoriaSeleccionada:{},
        productosList:[],
        subcategoriaSeleccionada:{},
        cargandoProductos:true,
        // subcategoriasCargadas:false

      }
    },
    watch:{ 
      searchQuery(val){
        if(val===''){                    
          this.getCategorias()
        }
      },
      subcategoriaSeleccionada(val){
        if(val===""){
          this.limpiarProductosList()
        }
      }
    },
    mounted(){
      this.getCategorias()
    },
    created(){
      this.buscarCategoriasDebounce = debounce(this.buscarCategorias,300)
      this.buscarSubcategoriasDebounce = debounce(this.buscarSubcategorias,300)
    },
    methods:{      
      abrirModalAgregarListado(){
        $("#agregarListadoModal").modal("show")
      },
      cerrarModalAgregarListado(){
        $("#agregarListadoModal").modal("hide")
      },
      getCategorias(){
        let self=this;       
        DynamicService.fetch("cat","categoria",{quitar_paginacion:true})
        .then((response)=>{          
          self.categoriasList=response.data          
        }).catch((error)=>{
          Notifications.alert.error(
            "Error al cargar categorías",
            error.response.data.error
          )
        })
      },
      buscarCategorias(texto){
        let self=this;              
        if(texto.length==0){
          self.limpiarCategoriaSeleccionada()
        }
        if(texto.length>0 && texto.length<3){
          self.categoriasList = []
          return;
        }
        DynamicService.getActionList("cat","categoria","buscador_categorias", {query: texto})
        .then((response)=>{         
          self.categoriasList = response.data      
          /*
          Siguiente validacion, ve si el usuario esta buscando otra categoria cuando ya
          hay una seleccionada
          */
          if(self.categoriasList.length!==0 && 
              Object.keys(self.categoriaSeleccionada).length!==0){              
              self.categoriaSeleccionada = {}
              self.subcategoriaSeleccionada = {}
              self.subcategoriasList = []
              self.limpiarProductosList()
              self.searchQuerySubcategoria=''
          }
                        
        }).catch((error)=>{
          Notifications.alert.error("Error al buscar categorías","Error "+error.response.data.error)               
        }) 
      },
      buscarSubcategorias(texto){
        //Busca subcategorías desde el input de subcategorías
        //buscador letra por letra por letra
        let self=this;           
        if(texto.length==0 && self.categoriaSeleccionada){ 
          self.subcategoriaSeleccionada = {}
          this.getSubcategoriasByCategoria(self.categoriaSeleccionada) 
        }

        if(texto.length>1 && texto.length<3){ //busca hasta que se agreguen 3 caracteres
          return
        }

        if(texto.length<=1){
          self.subcategoriasList = []
          return;
        }

        let params = {
          query:texto,
          categoria_id: self.categoriaSeleccionada.codigo,          
        }
     
        DynamicService.getActionList("cat","subcategoria","buscador_subcategorias", params)
        .then((response)=>{
          self.subcategoriasList = response.data          
          self.errores.errorSubcategoria=null     
           /*
          Siguiente validacion, ve si el usuario esta buscando otra subcategoria cuando ya
          hay una seleccionada
          */
          if(self.subcategoriasList.length!==0 && 
              Object.keys(self.subcategoriaSeleccionada).length!==0){              
              self.subcategoriaSeleccionada = {}
              self.limpiarProductosList()
          }

        }).catch((error)=>{        
          self.errores.errorSubcategoria=error.response.data.error
          self.limpiarSubcategoriaSeleccionada()
          self.subcategoriasList = []                   
        })
      },
      onSearchInputCategoria(){
        this.buscarCategoriasDebounce(this.searchQuery)
      },
      onSearchInputSubcategoria(){
        this.buscarSubcategoriasDebounce(this.searchQuerySubcategoria)
      },
      clickedCategoria(cat){
        //Función que se llama cuando se da click a una categoría 
        let self=this; 
        self.subcategoriaSeleccionada={}       
        self.searchQuery = cat.codigo
        self.getSubcategoriasByCategoria(cat)       
        // self.getProductosCategoria(cat)     
        self.categoriasList = self.categoriasList.filter(c => cat.codigo === c.codigo)//Para que solo se muestre la categoría seleccionada
        self.categoriaSeleccionada = cat;  
      },
      clickedSubcategoria(subcat){
        let self=this; 
        self.searchQuerySubcategoria = subcat.codigo
        self.subcategoriasList = self.subcategoriasList.filter(s => subcat.codigo === s.codigo)
        self.subcategoriaSeleccionada = subcat;        
        self.searchQuery = subcat.categoria.codigo 
        // self.getProductosBySubcategoria(subcat)   
      },
      getSubcategoriasByCategoria(cat){
        let self=this;
        let params= {
          categoria_id: cat.codigo
        }
        DynamicService.getActionList("cat","subcategoria","obtener_subcategorias_by_categoria", params)
        .then((response)=>{          
          self.subcategoriasList = response.data           
          self.errores.errorSubcategoria=null       
        }).catch((error)=>{
          Notifications.alert.error(
            "Error al cargar subcategorías",
            error.response.data.error
          )          
        })
      }, 
      limpiarCategoriaSeleccionada(){
        let self=this;        
        self.categoriaSeleccionada = {};
        self.searchQuery= '';
        self.searchQuerySubcategoria=''
        self.getCategorias()        
        self.limpiarSubcategoriaSeleccionada()
        self.subcategoriasList=[]
        // self.limpiarProductosList()
      },
      limpiarSubcategoriaSeleccionada(){
        let self=this;          
        if(self.categoriaSeleccionada && self.errores.errorSubcategoria===null){         
          //si hay una categoria seleccionada y no hay error en subcategoria (que no hay resultados) = trae las subcats de la cat      
          self.getSubcategoriasByCategoria(self.categoriaSeleccionada)
        }else{
          self.subcategoriasList = []
        }
        self.subcategoriaSeleccionada = {};          
        self.searchQuerySubcategoria = '';    
        self.limpiarProductosList()  
      },
      limpiarProductosList(){
        let self=this;
        self.productosList = []
        self.cargandoProductos = true;
      }, 
      agregarCategoria(cat){
        let self=this;        
       
        //pide confirmación  
        Notifications.alert.confirm(
          "Agregar Categoria",
          "¿Esta seguro(a) que desea agregar todos los productos de la categoría?",
          "si",
          function(){
            let params= {
              categoria: cat.codigo,
              cuponera: self.cuponera
            }
            DynamicService.postActionList("cat", "cuponera-sku", "guardar_categoria_cuponera", params)
            .then((response)=>{              
              Notifications.alert.success(
                "Agregar Categoría",
                "Se agregaron los productos de la categoría al cupón"              
              )                            
              self.limpiarCategoriaSeleccionada()
              self.$emit("refreshCuponeraSku",{page:1})             
            }).catch((error)=>{
              Notifications.alert.error(
                "Agregar Categoría",
                "Error "+error.response.data.error
              )
            })
          }
        );
      },
      agregarSubcategoria(subcat){
        //agrega una subcategoría al cupón
        let self=this;
        console.log("agregando subcategoría",subcat.codigo)        
         Notifications.alert.confirm(
          "Agregar Subcategoría",
          "¿Esta seguro(a) que desea agregar todos los productos de la subcategoría?",
          "Si",
          function(){
            let params={
            subcategoria : subcat.codigo,
            cuponera: self.cuponera,
            }
            DynamicService.postActionList("cat", "cuponera-sku","guardar_subcategoria_cuponera", params)
              .then((response)=>{   
                console.log(response.data)     
                Notifications.alert.success(
                  "Agregar Productos",
                  "Productos agregados exitosamente"
                )
                self.$emit("refreshCuponeraSku",{page:1})
                self.cerrarModalAgregarListado()
              }).catch((error)=>{
                console.log("error al guardar subcat...", error)
                  Notifications.alert.error(
                    "Error al guardar subcategorías",
                    "Error "+error
                  )
              })            
          }
        );
      }, 
    }
  }
</script>
  

<style>
  .efecto-hover:hover{
    background-color: blue !important;

  }
</style>